import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/providers/api.service';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';
import { COUNTRY_CODES } from 'src/app/shared/data/country-codes';

@Component({
  selector: 'sm-edit-business-details',
  templateUrl: './edit-business-details.component.html',
  styleUrls: ['./edit-business-details.component.scss']
})
export class EditBusinessDetailsComponent implements OnInit {
  entityDetails: {
    entityName: string,
    entityPhone: string,
    entityDesc: string,
    entity_email: string,
    ownerName: string,
    ownerPhone: string,
    referenceNo: string,
    business_website_address: string
  } = {
    entityName: "",
    entityPhone: "",
    entityDesc: "",
    entity_email: "",
    business_website_address: "",
    ownerName: "",
    ownerPhone: "",
    referenceNo: ""
  }
  apisub:Subscription
  constructor(@Inject(MAT_DIALOG_DATA) public parentdata: any, public loader: LoaderServiceService, private apiservice: ApiService, private activemodal: MatDialogRef<EditBusinessDetailsComponent>) {

    this.apisub = this.apiservice.apiResult.subscribe(resdata =>{
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_UPDATE_ENTITY_DETAILS){
        if(resdata.result){
          this.activemodal.close({msg: 'success'})
        }
      }
    })

   }

  ngOnInit(): void {
   
        this.entityDetails.entityName = this.parentdata.entityDetails.entityName && this.parentdata.entityDetails.entityName != 'null' ? this.parentdata.entityDetails.entityName : null  
        this.entityDetails.entityPhone = this.parentdata.entityDetails.entityPhone && this.parentdata.entityDetails.entityPhone != 'null' ? this.parentdata.entityDetails.entityPhone : null  
        this.entityDetails.entityDesc = this.parentdata.entityDetails.entityDesc && this.parentdata.entityDetails.entityDesc != 'null' ? this.parentdata.entityDetails.entityDesc : null  
        this.entityDetails.entity_email = this.parentdata.entityDetails.entity_email && this.parentdata.entityDetails.entity_email != 'null' ? this.parentdata.entityDetails.entity_email : null  
        this.entityDetails.business_website_address = this.parentdata.entityDetails.business_website_address && this.parentdata.entityDetails.business_website_address != 'null' ? this.parentdata.entityDetails.business_website_address : null  
        this.entityDetails.ownerName = this.parentdata.entityDetails.ownerName  && this.parentdata.entityDetails.ownerName != 'null' ? this.parentdata.entityDetails.ownerName : null
        this.entityDetails.ownerPhone = this.parentdata.entityDetails.ownerPhone && this.parentdata.entityDetails.ownerPhone != 'null' ?  this.parentdata.entityDetails.ownerPhone : null  
        this.entityDetails.referenceNo = this.parentdata.entityDetails.referenceNo && this.parentdata.entityDetails.referenceNo != 'null' ? this.parentdata.entityDetails.referenceNo : null 
        this.entityCountryCode = this.parentdata.entityDetails.entity_country_code ? this.countryList.find(country => country.dial_code === this.parentdata.entityDetails.entity_country_code) :  this.countryList.find(country => country.dial_code === '+91')
        this.ownerCountryCode = this.parentdata.entityDetails.owner_country_code ? this.countryList.find(country => country.dial_code === this.parentdata.entityDetails.owner_country_code) :  this.countryList.find(country => country.dial_code === '+91')
        
        console.log(this.entityDetails);
  }
  checkForm(){
    if(this.parentdata.entityDetails.entity_type == 2){
      if(!this.entityDetails.entityName || !this.entityDetails.entityPhone || this.entityDetails.entityPhone.length < 3  || !this.entityDetails.entityDesc){
        return true
      }
      else{
         return false
      }
    }
    else{
      if(!this.entityDetails.entityName || !this.entityDetails.entityPhone || this.entityDetails.entityPhone.length < 3 || !this.entityDetails.entityDesc || !this.entityDetails.ownerName || !this.entityDetails.ownerPhone){
        return true
      }
      else{
        return false
      }
    }
  }
  onSave(){
    let obj = {
      "entity_hash": this.parentdata.entityDetails.hashId,
      "business_name": this.entityDetails.entityName,
      "phone": this.entityDetails.entityPhone,
      "description": this.entityDetails.entityDesc,
      "email": this.entityDetails.entity_email ?? null,
      "business_website_address": this.entityDetails.business_website_address ?? null,
      "owner_name": this.entityDetails.ownerName ?? null,
      "owner_phone": this.entityDetails.ownerPhone ? this.entityDetails.ownerPhone : null,
      "registration": this.entityDetails.referenceNo ?? null,
      "entityCountryCode": this.entityCountryCode.dial_code,  
      "ownerCountryCode": this.ownerCountryCode.dial_code,
      "currency": this.parentdata.entityDetails.currency, 
      "currencySymbol": this.parentdata.entityDetails.currency_symbol
    }
  console.log(obj)
    this.loader.showLoader = true
    this.apiservice.updateEntityDetails(obj)
  }
countryList: {name: string; dial_code: string; code: string; flag: string; preferred?: any;}[] = COUNTRY_CODES;
entityCountryCode:any 
ownerCountryCode:any 
searchString: UntypedFormControl = new UntypedFormControl('');
onCountrySelected(event: any): void {
  this.searchString.reset()
  this.countryList = COUNTRY_CODES
}

onKey() { 
  console.log(this.searchString.value);
  
  this.countryList= []; 
  this.selectSearch(this.searchString.value);       
}
selectSearch(value:string){
  let filter = value.toLowerCase();
  for ( let i = 0 ; i < COUNTRY_CODES.length; i ++ ) {
      let option = COUNTRY_CODES[i];
      if (  option.name.toLowerCase().indexOf(filter) >= 0) {
          this.countryList.push( option );
      }
  }
}
}
